import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import './styles.css';

interface PropsType {}

const Redirect: React.FC<PropsType> = () => {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // useEffect(() => {
  //   if (countdown === 0) {
  //     // Add your redirection logic here
  //   }
  // }, [countdown]);

  return (
    <>
      <div className='loader w-100 d-flex justify-content-center align-items-center'>
        <Spinner animation='border' variant='primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </Spinner>
        <p className='text-center text-white'>
          Redirecting in {countdown} seconds. Please don&apos;t close this page.
        </p>
      </div>
    </>
  );
};

export default Redirect;
